import yn from 'yn'
import VueSocketIO from 'vue-socket.io'
import Vue from 'vue'
import store from '@/store'

import SocketIO from 'socket.io-client'

const url = process.env.VUE_APP_MESSAGE_SERVER_URL + process.env.VUE_APP_MESSAGE_NAMESPACE
export const io = SocketIO(url, { reconnectionAttempts: 5 })
export const vueSocketIO = new VueSocketIO({
  debug: yn(process.env.VUE_APP_DEBUG),
  connection: io,
  vuex: {
    store,
    actionPrefix: 'SOCKET_'
  }
})

Vue.use(vueSocketIO)
